/**
 * Exclusive Elite Plans family landing (mirrors `/new-elite-family-landing`).
 *
 * Belongs here:
 * - Primary free → sell body with blocked Upgrade CTA
 * - Primary Elite/Prime + secondary free → FamilyPurchaseBody on both tabs
 * Does not belong here: family member dashboard (`/elite-plans-family-member`).
 */
import '../elitePlansTheme.css'
import { ElitePlansLandingProvider, useElitePlansLanding } from '../ElitePlansLandingContext'
import { ElitePlansAnalyticsScreen } from '../constants/analyticsEvents'
import { ELITE_PLANS_FAMILY_LANDING_STATUS_QUERY_KEY } from '../constants/queryKeys'
import { resolveIsFamilyPurchase } from '../elitePlansMembership'
import { EliteBuyCtaExtrasProvider } from '../../../components/elite/EliteBuyCtaExtrasContext'
import { ElitePlansPageShell } from '../components/ElitePlansPageShell'
import { ElitePlansHeader } from '../components/ElitePlansHeader'
import { ElitePlansTabPanel } from '../components/ElitePlansTabPanel'
import { ElitePlansTabbedPageLayout } from '../components/ElitePlansTabbedPageLayout'
import { ElitePlansSellBody } from '../components/ElitePlansSellBody'
import { ElitePlansFamilyPurchaseBody } from '../components/ElitePlansFamilyPurchaseBody'
import { ElitePlansHeroStatusSkeleton } from '../components/hero/ElitePlansHeroStatusSkeleton'
import { useTrackElitePlansScreenLoadWhenReady } from '../hooks/useTrackElitePlansScreenLoadWhenReady'

export default function ElitePlansFamilyLandingPage() {
  return (
    <ElitePlansLandingProvider
      analyticsScreen={ElitePlansAnalyticsScreen.FamilyLanding}
      statusQueryKeyRoot={ELITE_PLANS_FAMILY_LANDING_STATUS_QUERY_KEY}
    >
      <ElitePlansFamilyLandingPageContent />
    </ElitePlansLandingProvider>
  )
}

function ElitePlansFamilyLandingPageContent() {
  const { status, isStatusLoading } = useElitePlansLanding()
  useTrackElitePlansScreenLoadWhenReady(!isStatusLoading)

  // Wait for status — do not flash SellBody before FamilyPurchase resolves
  if (isStatusLoading) {
    return (
      <ElitePlansPageShell isContentScrollOwner bottomInsetPx={24}>
        <ElitePlansHeader />
        <ElitePlansTabPanel>
          <ElitePlansHeroStatusSkeleton showTenure showPlusBanner />
        </ElitePlansTabPanel>
      </ElitePlansPageShell>
    )
  }

  // Primary Elite or Prime + secondary free → FamilyPurchase on Elite and Prime tabs
  if (resolveIsFamilyPurchase(status)) {
    return (
      <EliteBuyCtaExtrasProvider status={status}>
        <ElitePlansPageShell isContentScrollOwner bottomInsetPx={24}>
          <ElitePlansHeader />
          <ElitePlansTabPanel>
            <ElitePlansFamilyPurchaseBody />
          </ElitePlansTabPanel>
        </ElitePlansPageShell>
      </EliteBuyCtaExtrasProvider>
    )
  }

  // Primary free / FAMILY_ONBOARDING_NOT_ALLOWED → sell landing (blocked CTA from hero)
  return (
    <ElitePlansTabbedPageLayout>
      <ElitePlansSellBody />
    </ElitePlansTabbedPageLayout>
  )
}
